import { useState } from 'react';
import MainLayout from '../../../components/layout/MainLayout';

export default function OrderConfigPage() {
  const [autoCancelTime, setAutoCancelTime] = useState(30);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = () => {
    if (autoCancelTime < 1 || autoCancelTime > 1440) {
      alert('请输入1-1440之间的数值');
      return;
    }

    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      alert('保存成功！');
    }, 500);
  };

  return (
    <MainLayout>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">订单配置</h1>
        </div>

        <div className="bg-white rounded-lg p-6">
          <div className="max-w-2xl">
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                订单自动取消时间
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="number"
                  value={autoCancelTime}
                  onChange={(e) => setAutoCancelTime(Number(e.target.value))}
                  min="1"
                  max="1440"
                  className="w-32 px-3 py-2 border border-gray-300 rounded-lg text-sm"
                />
                <span className="text-sm text-gray-600">分钟</span>
              </div>
              <p className="mt-2 text-xs text-gray-500">
                未支付订单将在设置的时间后自动取消（范围：1-1440分钟）
              </p>
            </div>

            <div className="flex items-center gap-3 pt-4 border-t">
              <button
                onClick={handleSave}
                disabled={isSaving}
                className="px-6 py-2 bg-teal-500 text-white rounded-lg text-sm hover:bg-teal-600 disabled:bg-gray-300 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSaving ? '保存中...' : '保存配置'}
              </button>
              <button
                onClick={() => setAutoCancelTime(30)}
                className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm hover:bg-gray-50 whitespace-nowrap"
              >
                恢复默认
              </button>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
